<template>
  <div class="home">
    <van-nav-bar title="地址维护" left-text="返回" right-text left-arrow fixed @click-left="onClickLeft" />
    <div style="height:46px"></div>
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      :disabled-list="disabledList"
      disabled-text="以下地址超出配送范围"
      default-tag-text="默认"
      @add="onAdd"
      @edit="onEdit"
      @select = "selAddress"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { AddressList } from "vant";

Vue.use(AddressList);
export default {
  name: "addressList",
  data() {
    return {
      user: { token: "", user: {} },
      chosenAddressId: "1",
      list: [],
      disabledList:[],
       
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    selAddress(item){
        localStorage.setItem("address",item.id);
        this.$router.go(-1);
    //   this.$router.push('/user/addressadd/'+item.id);  
    },
    onAdd() {
      this.$router.push("/user/addressadd/0");
    },
    onEdit(item) {
      this.$router.push('/user/addressadd/'+item.id);
    },
    getList() {
      this.$http
        .get(this.GLOBAL.API + "s_shop/address/listAddress", {
          params: {},
          headers: { "XX-Token": this.user.token, "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          if (data.code == 1) {
              
            this.list = data.data;
          }else{
              this.$toast(data.msg);
          }
        });
    }
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user"))) {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  background-color: #f6f6f6;
}
</style>